// AdditionalServicesSection.js
import React from 'react';
import hospiceCareImage from '../assets/hospice-care-showcase.jpg';
import specialtyCareImage from '../assets/specialty-care-showcase.jpg';

const AdditionalServicesSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto space-y-16">
        
        {/* Hospice Care */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img 
              src={hospiceCareImage} 
              alt="Caregiver with elderly woman" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Hospice Care
            </h3>
            
            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Hospice care provides compassionate support for seniors with life-limiting conditions and their families. The caregivers we refer focus on comfort, dignity, and quality of life, assisting with daily needs while providing emotional support. This approach allows seniors to spend their final days in the familiarity of home, surrounded by care and compassion.
              </p>
              
              <p>
                Families benefit from reassurance and guidance during this sensitive time. By providing support for both seniors and their loved ones, our caregivers help reduce stress, manage symptoms, and ensure that every day is as comfortable and meaningful as possible. Our hospice care involves:
              </p>
            </div>
            
            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Comfort-focused care</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Emotional support</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Daily living assistance</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Specialty Care */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Specialty Care
            </h3>
            
            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Our specialty care services are designed for seniors and adults with unique health needs or chronic conditions that require focused attention. The caregivers we match provide personalised support tailored to each individual, ensuring comfort, safety, and well-being. From managing complex medical routines to assisting with specialised equipment, our goal is to help clients maintain independence while receiving the care they need.
              </p>
              
              <p>
                Families can trust our caregivers to provide compassionate, consistent support that enhances daily life. By coordinating with healthcare providers and creating customised care plans, we ensure each client receives the right level of attention, promoting both physical health and emotional well-being.
              </p>
              
              <p className="font-normal">Our services include:</p>
            </div>
            
            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Chronic condition support</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Care coordination</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Personalised routines</span>
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div>
            <img 
              src={specialtyCareImage} 
              alt="Caregiver with elderly couple" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServicesSection;
